<template>
  <div class="personal-info-summary">
    <div class="top-line">
      <div class="title">פרטי בעל הכרטיס</div>
      <div class="edit" v-on:click="openEditPopup">
        עריכה
        <img class="pencil" :src="require('@/assets/subscription/edit_icon.svg')"/>
      </div>
    </div>
    <div v-for="(personalDetail, index) in personalDetails" :key="index">
      <div class="field-name">{{ personalDetail.title }}</div>
      <div class="value">{{ personalDetail.value }}</div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState, mapGetters } from 'vuex';
import ModalBus from '@/event-bus/modal-bus';
import EditPersonalInfoPopup
  from '@/pages/responsive-pages/authenticated/subscription/components/EditPersonalInfoPopup';

export default {
  name: 'PersonalInfoSummary',
  computed: {
    ...mapGetters('subscription', ['personalInfoFields']),
    ...mapState('subscription', ['personalInfo']),
    personalDetails() {
      const details = [
        { fieldName: this.personalInfoFields.firstName, title: 'שם פרטי' },
        { fieldName: this.personalInfoFields.lastName, title: 'שם משפחה' },
        { fieldName: this.personalInfoFields.phoneNumber, title: 'נייד' },
      ];
      return _.map(details, ({ fieldName, title }) => {
        return { value: this.personalInfo[fieldName].value, title };
      });
    },
  },
  methods: {
    openEditPopup() {
      ModalBus.$emit('open', {
        component: EditPersonalInfoPopup,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~base-ui/src/scss/riseup-colors';

  .personal-info-summary {
    font-family: SimplerPro;
    margin-bottom: 30px;

    .top-line {
      display: flex;
      justify-content: space-between;
      font-size: 16px;
      font-weight: bold;

      .title {
        margin-bottom: 20px;
      }

      .edit {
        cursor: pointer;
        color: $riseup_blue;

        .pencil {
          width: 10px;
        }
      }
    }

    .field-name {
      padding-top: 14px;
      font-size: 14px;
      line-height: 1;
    }
    .value {
      font-size: 20px;
      font-weight: bold;
      margin: 6px 0 9px;
      line-height: 1;
    }
  }
</style>
